import { Offer } from 'graphql/models/extended'
import { OfferBase } from 'models/offer.model';

export function isInProgressForTheOtherUser(offer: any, isDealer: boolean) {
    // checking if the offer is 'work in progress' at the other user (dealer vs manufacturer)
    if (isDealer) {
        return offer?.createdByType === 'MANUFACTURER' && offer.status === 'InProgress';
    } else {
        return offer?.createdByType === 'DEALER' && offer.status === 'InProgress';
    }
}

export function mergeOfferPricingState(offer: Offer, updates: Offer | OfferBase): Offer {
    return {
        ...offer,
        autoUpdatePrices: updates.autoUpdatePrices !== undefined ? updates.autoUpdatePrices : offer.autoUpdatePrices,
        priceIsOutdated: updates.priceIsOutdated !== undefined ? updates.priceIsOutdated : offer.priceIsOutdated,
    }
}
